import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import { ToastMessage } from "../../components/ToastMessage";
import Toggle from "../../components/Toggle";
import { uploadEventImage } from "../../services/eventsService";
import { Colors, NEW_PARK_VISIT_TIME_INIT } from "../../config/Constants";
import { validatePromo } from "./validatePromo";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { useLoadContext } from "../../contexts/LoadContext";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import InfoAndText from "../../components/ManageParks/InfoAndText";
import PromoHeader from "../../components/ManagePromo/PromoHeader";
import {
  addPromo,
  fetchPromoFromId,
  updatePromo,
} from "../../services/promoServices";
import AddPromoForm from "../../components/ManagePromo/AddPromoForm";
import { getSettings } from "../../services/settingsService";
import { fetchAllActiveParks } from "../../services/parksService";
import {
  getAddpromoData,
  getFomattedpromoData,
  getFormattedDiscountTypes,
  getFormattedParks,
  getFormattedPromoTime,
} from "../../helper";
import { fetchOutletFromId } from "../../services/outletsService";
import { fetchAllActiveProducts, fetchAllProducts } from "../../services/productService";

interface StatusProps {
  status: boolean;
}

const AddPark = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(true);
  const [parks, setParks] = useState([]);
  const [discounts, setDiscountType] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [products, setProducts] = useState<any[]>([]);
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [promoData, setPromoData] = useState({
    code: "",
    title: "",
    description: "",
    isUnlimited: true,
    discountType: "",
    percentage: "",
    isPublic: true,
    startDate: "",
    endDate: "",
    // startTime: "00:00",
    // endTime: "23:59",
    outlet: "",
    products: new Array<string>(),
    imageUrl: "",
    showInApp: true,
    isActive: true,
    tag: new Array<string>(),
    maxUseCount: 0,
    countPerUser: 0,
    maxQtyApplicable: 0,
    freeProduct: "",
    isFreeProduct: false,
  });
  const [error, setError] = useState({
    code: "",
    title: "",
    description: "",
    isUnlimited: "",
    discountType: "",
    percentage: "",
    isPublic: "",
    startDate: "",
    endDate: "",
    // startTime: "",
    // endTime: "",
    outlet: "",
    products: "",
    imageUrl: "",
    timeSingle: "",
    timeType: "",
    time: {},
    maxUseCount: "",
    countPerUser: "",
    maxQtyApplicable: "",
    freeProduct: "",
    isFreeProduct: "",
  });
  const { setLoader } = useLoadContext();
  const [time, setTime] = useState({
    type: "",
    timeMulti: { ...NEW_PARK_VISIT_TIME_INIT },
    timeSingle: { start: "", end: "" },
  });

  const uploadEvent = async (event: any) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = async () => {
      if (
        event.target.files[0].size > 2048756
        // ||
        // img.width > 327 ||
        // img.height > 106
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else {
        try {
          setLoader(true);
          let { data } = await uploadEventImage(event.target.files[0]);
          let formData = { ...promoData };
          let formError = { ...error };

          formData["imageUrl"] = data.files[0];

          console.log(formData);

          setPromoData(formData);
          setError({ ...formError, imageUrl: "" });
        } catch (error: any) {
          toast.error(<ToastMessage message="File cannot be uploaded." />, {
            hideProgressBar: true,
          });
        } finally {
          setLoader(false);
        }
      }
    };
  };

  const handleChange = (event: any) => {
    if (event.target.name === "imageUrl") {
      uploadEvent(event);
      setError({ ...error, imageUrl: "" });
    } else if (event.target.name === "products") {
      let prodArray: string[] = [...promoData.products];
      let prodId: string = event.target.value;
      let isIncluded = prodArray.includes(prodId);
      setError({ ...error, products: "" });

      if (isIncluded) {
        let index = prodArray.indexOf(prodId);
        prodArray.splice(index, 1);
      } else {
        prodArray.push(prodId);
      }
      setPromoData({ ...promoData, products: prodArray });
    } else {
      let formData = { ...promoData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      if (
        event.target.name === "discountType" &&
        event.target.value === "product" &&
        formData.outlet === "all"
      ) {
        formData.outlet = "";
      }
      if (
        event.target.name === "discountType" &&
        event.target.value === "cart"
      ) {
        formError.products = "";
        formData.products = [];
        formError["freeProduct"] = "";
        formData["freeProduct"] = "";
        formData["isFreeProduct"] = false;
        formData["percentage"] = "0";
      }
      if (
        event.target.name === "startDate" ||
        event.target.name === "endDate"
      ) {
        formError["timeType"] = "";
        formError["time"] = {};
        formError["timeSingle"] = "";
      }
      if (event.target.name === "isFreeProduct") {
        formError["freeProduct"] = "";
        formData["freeProduct"] = "";
        formData["percentage"] = "0";
      }
      //@ts-ignore
      formError[event.target.name] = "";
      setPromoData(formData);
      setError(formError);
    }
  };

  const handleCancel = () => {
    setIsCancelModal(true);
  };

  const handleSubmit = () => {
    if (!validatePromo(promoData, time, setError)) {
      setError({
        code: "",
        title: "",
        description: "",
        isUnlimited: "",
        discountType: "",
        percentage: "",
        isPublic: "",
        startDate: "",
        endDate: "",
        // startTime: "",
        // endTime: "",
        outlet: "",
        products: "",
        imageUrl: "",
        timeSingle: "",
        timeType: "",
        time: {},
        maxUseCount: "",
        countPerUser: "",
        maxQtyApplicable: "",
        freeProduct: "",
        isFreeProduct: "",
      });
      console.log(getAddpromoData(promoData, time));

      if (id) {
        updateData(getAddpromoData(promoData, time));
      } else {
        saveData(getAddpromoData(promoData, time));
      }
    }
  };

  const saveData = async (data: any) => {
    try {
      let response = await addPromo(data);
      if (response.status === 201) {
        setIsSuccessModal(true);
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };
  const updateData = async (data: any) => {
    try {
      setLoader(true);
      let response = await updatePromo(data, id);
      if (response.status === 200) {
        setIsSuccessModal(true);
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    } finally {
      setLoader(false);
    }
  };

  const handleActiveToggle = () => {
    setPromoData({ ...promoData, isActive: !promoData.isActive });
  };

  const handleShowAppToggle = () => {
    let formError = { ...error };
    setError({ ...formError, imageUrl: "" });
    setPromoData({ ...promoData, showInApp: !promoData.showInApp });
  };

  const removeImage = () => {
    let formData = { ...promoData };
    let formError = { ...error };
    //@ts-ignore
    formData.imageUrl = "";
    setPromoData(formData);
    setError(formError);
  };

  useEffect(() => {
    if (id) {
      fetchPromoDetails(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    fetchDatas();
  }, []);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    let settings = await getSettings("cms");
    let discountList = getFormattedDiscountTypes(
      settings?.data?.data?.promotion_discount_types
    );

    discountList.push({
      label: "Select Discount Type",
      value: "",
    });
    discountList.unshift(discountList.pop());
    setDiscountType(discountList);
    setTagsList(settings?.data?.data?.promotion_tags);
  };

  const fetchDatas = async () => {
    let parks = await fetchAllActiveParks();
    let parkList = getFormattedParks(parks?.data?.data);
    parkList.push({
      label: "All Parks eligible for this offer",
      value: "all",
    });
    parkList.unshift(parkList.pop());
    parkList.push({
      label: "Select Park",
      value: "",
    });
    parkList.unshift(parkList.pop());
    setParks(parkList);
  };

  const fetchPromoDetails = async (id: string) => {
    setLoader(true);
    try {
      let { data } = await fetchPromoFromId(id);
      let activeProductOptions: any[] = [];

      if (data?.data?.outlet) {
        let outlet = await fetchOutletFromId(data?.data?.outlet);
        let products = await fetchAllActiveProducts(
          outlet?.data?.data?.shortName,
          outlet?.data?.data?._id
        );
        activeProductOptions = getFormattedParks(products?.data?.data || []);
        setProducts(activeProductOptions);
      }
      if (data.code === 200) {
        setLoader(false);
        const formattedPromoData = getFomattedpromoData(data.data);

        // Remove inactive/hidden and duplicate product IDs returned by the API.
        // This keeps the payload aligned with the products visible as selected.
        if (formattedPromoData.discountType === "product") {
          const activeProductIds = new Set(
            activeProductOptions.map((product: any) => product.value)
          );
          formattedPromoData.products = Array.from(
            new Set<string>(formattedPromoData.products || [])
          ).filter((productId) => activeProductIds.has(productId));
        }

        setPromoData(formattedPromoData);
        // @ts-ignore
        setTime(getFormattedPromoTime(data?.data));
      }
    } catch (error: any) {
      setLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleParkChange = async (e: any) => {
    setPromoData({
      ...promoData,
      [e.target.name]: e.target.value,
      // discountType: e.target.value === "all" ? "cart" : promoData.discountType,
      products: [],
    });
    setError({ ...error, outlet: "", products: "" });

    let outlet = await fetchOutletFromId(e.target.value);
    let { data } = await fetchAllActiveProducts(
      outlet?.data?.data?.shortName,
      outlet?.data?.data?._id
    );
    setProducts(getFormattedParks(data?.data));
  };

  const handleTagSelect = (item: { label: string; selected: boolean }) => {
    let tags: any[] = [...promoData.tag];
    if (item.label === "none") {
      tags = [];
    } else {
      // ts-ignore
      let index = tags?.indexOf(item.label);
      if (index >= 0) {
        tags.splice(index, 1);
      } else {
        tags.push(item.label);
      }
    }
    setPromoData({ ...promoData, tag: tags });
    setError({ ...error, imageUrl: "" });
  };

  const handleTimeSelect = (value: any, fromTo: any, name: any) => {
    if (name === "timeSingle") {
      let timeObj = { ...time.timeSingle };
      //@ts-ignore
      timeObj[fromTo] = value;
      setError({ ...error, timeSingle: "" });
      setTime({ ...time, timeSingle: { ...timeObj } });
    } else {
      let timeObj = { ...time.timeMulti };
      let err = { ...error };
      //@ts-ignore
      timeObj[name][fromTo] = value;
      //@ts-ignore
      err["time"][name] = "";
      setTime({ ...time, timeMulti: { ...timeObj } });
      setError(err);
    }
  };

  const handlePromoTimeTypeChange = (e: any) => {
    setTime({
      type: e.target.value,
      timeMulti: {
        mon: {
          start: "",
          end: "",
        },
        tue: {
          start: "",
          end: "",
        },
        wed: {
          start: "",
          end: "",
        },
        thu: {
          start: "",
          end: "",
        },
        fri: {
          start: "",
          end: "",
        },
        sat: {
          start: "",
          end: "",
        },
        sun: {
          start: "",
          end: "",
        },
      },
      timeSingle: { start: "", end: "" },
    });
    setError({ ...error, timeType: "", time: {}, timeSingle: "" });
  };

  return (
    <>
      <StyledDiv>
        <PromoHeader label={id ? "Edit Promo" : "Create Promo"} />
        <InfoWrapper>
          <InfoAndText text="(This toggle is to activate and deactivate the Promotion)" />
          <StyledStatus>
            Status:
            <Toggle
              uniqueName={"status"}
              isChecked={promoData?.isActive}
              onChange={handleActiveToggle}
            />
            <ActiveDeactive status={promoData?.isActive}>
              {promoData?.isActive ? "Active" : "Inactive"}
            </ActiveDeactive>
          </StyledStatus>
        </InfoWrapper>
      </StyledDiv>
      <AddPromoForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        onChange={handleChange}
        onParkChange={handleParkChange}
        onRemove={removeImage}
        value={promoData}
        error={error}
        parks={parks}
        products={products}
        discounts={discounts}
        onShowAppToggle={handleShowAppToggle}
        onTagSelect={handleTagSelect}
        tagsList={tagsList}
        onTimeSelect={handleTimeSelect}
        time={time.timeMulti}
        timeType={time.type}
        timeSingle={time.timeSingle}
        onPromoTimeChange={handlePromoTimeTypeChange}
      />
      <br />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
      {isSuccessModal && (
        <ErrorSuccessModal
          variant="success"
          heading="Promo details saved successfully."
          buttonLabel="Ok"
          setOpenOrClose={setIsSuccessModal}
          onSubmit={() => {
            setIsSuccessModal(false);
            navigate(-1);
          }}
        />
      )}
      {isCancelModal && (
        <ConfirmModal
          heading="Are you sure you want to leave ?"
          subHeading="Hey there! It looks like you're in the middle of something and you haven't saved all of your content. Save before you go!"
          button2Label="Save"
          button1Label="Leave"
          button1Submit={() => {
            setIsCancelModal(false);
            navigate(-1);
          }}
          button2Submit={() => {
            setIsCancelModal(false);
          }}
          setOpenOrClose={setIsCancelModal}
        />
      )}
    </>
  );
};

export const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    margin: 1.5625rem 1.5625rem 0 1.5625rem;
  }
`;
export const StyledStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.8125rem;
`;
export const ActiveDeactive = styled.div<StatusProps>`
  color: ${(props) => (props.status ? Colors.appleGreen : Colors.appleRed)};
  margin: 0 0.5rem;
`;

export default AddPark;
